export default "__VITE_ASSET__adf21fc4__"